export const FEED = 'feed';
export const PROJECT = 'project';
export const PROJECT_PUBLIC = 'public/project';
// export const PROJECT = 'project';
export const FAVORITES = 'favorites';
export const AUDIO = 'audio';
export const NOTIFICATION = 'v2/notification';
export const PAYMENT = 'paypro';
export const ORTC_AUTH = 'ortc/auth';
export const NOTIFICATION_ADD_TUNE = 'notification/add-tune';
export const MESSENGER_SEND = 'messenger/send';
export const CHAT = 'chat';
export const SHARE = 'share';
export const USER_PROJECT = 'user-project';
export const EVENT = 'event';
export const MY_COLLECTION = 'my-collection';
export const TRACK = 'track';
export const INVITE = 'invite';
export const SIGNUP = 'signup';
export const SIGNUP_STUDENT = 'signup/student';
export const SIGNUP_TEACHER = 'signup/teacher';
export const SIGNUP_DEMO = 'public/signup/demo';
export const SIGNUP_GOOGLE_AUTH = 'signup/google-auth';
export const MANAGE_STUDENTS = 'manage/students';
export const MANAGE_TEACHERS = 'manage/teachers';
export const MANAGE_STUDENT = 'manage/student';
export const MANAGE_LOGIN = 'manage/login';
export const MANAGE_STUDENT_PUBLIC = 'public/manage/student';
export const MANAGE_MAGIC_LINK = 'manage/teacher/magic-link';
export const STUDENT_ACTIVITIES = 'project/activities/student';
export const PROJECT_ACTIVITIES = id => `project/${id}/activities`;
export const MODULE = 'module';
export const VIDEO_CHAT = 'video/chat';
export const VIDEO = 'video';

// export const STUDENT_ACTIVITIES = 'project/activities/student';
// export const PROJECT_ACTIVITIES = id => `project/${id}/activities`;
export const GROUP = 'group';
export const SCHOOL = 'manage/school';
export const SYNC_USER = 'manage/sync';
export const CODE = 'public/signup/code';
export const FOLDER = 'folder';
export const CANCEL_SUBSCRIPTION = 'payment/cancel-subscription';
